export const Routes = {
  APP_INBOX: '/AppInbox',
  ANALYTICS: '/Analytics',
  APP_VERSIONING: '/AppVersioning',
  COMPASS_CONFIGURATIONS: '/CompassConfigurations',
  COMPASS_ERROR_LOG: '/CompassErrorLog',
  DEVICE_FIRMWARE: '/DeviceFirmware',
  DEVICE_MANAGEMENT: '/DeviceManagement',
  DFU_FILE_MANAGEMENT: '/DFUFileManagement',
  EMERGENCY_HISTORY: '/EmergencyHistory',
  EMERGENCY_RESPONDER_MANAGEMENT: '/EmergencyResponseManagement',
  HELP: '/Help',
  HOME: '/',
  INSIGHTS: '/Insights',
  MANUFACTURING: '/Manufacturing',
  ORGANIZATION: '/Organization',
  ORGANIZATION_MANAGEMENT: '/OrganizationManagement',
  PROTOTYPE_FIRMWARE: '/PrototypeFirmware',
  PROFILE: '/Profile',
  SIGN_UP: '/signup',
  SUPPORT_LINKS: '/SupportLinks',
  USER_MANAGEMENT: '/UserManagement',
  USER_MANAGEMENT_ALL_USERS: '/UserManagement/all-users',
  COMPASS_CORE: '/CompassCore',
};
